<template>
  <aside class="aside-menu">

  </aside>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// src/components/Aside.vue